module.exports = __webpack_public_path__ + "static/media/title.f170d3ea.png";